import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductAllowedQuantityComponent } from './product-allowed-quantity.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { AlertComponent } from '../../../../../../components/alert/alert.component';
import { ProductChangesComponent } from './product-changes/product-changes.component';

@NgModule({
  declarations: [ProductAllowedQuantityComponent],
  imports: [CommonModule, AlertComponent, ProductChangesComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductAllowedQuantity: {
          component: ProductAllowedQuantityComponent,
        },
      },
    }),
  ],
})
export class ProductAllowedQuantityModule {}
